import React from 'react';

import iconTrackingDisable from 'img/icon-stock-not-available.svg';

import {
  ContainerTracking,
  ImgNoTracking,
  ContainerDescription,
  TitleTracking,
  DescriptionTracking,
  BtnTracking
} from './styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { HideTrackingProps } from './interface';
import CreateProtocolServices from 'services/createProtocol.service';

const HideTracking: React.FC<HideTrackingProps> = (props) => {
  const { order } = props;
  const user = useSelector((state: RootState) => state.user);
  const _createProtocolServices = new CreateProtocolServices();
  const shouldDisableCustomerPageTrackingProtocol =
    window.location.pathname === '/cliente'
    && CreateProtocolServices.isAutoAttendanceProtocolDisabled(user);

  const createProtocol = async () => {
    await _createProtocolServices.createProtocol(order, user);
  };

  return (
    <ContainerTracking>
      <ImgNoTracking src={iconTrackingDisable} />
      <ContainerDescription>
        <TitleTracking>Tracking indisponível</TitleTracking>
        <DescriptionTracking>
          {shouldDisableCustomerPageTrackingProtocol ? (
            <>Desculpe, mas esse pedido não possui seu tracking disponível no momento. Para mais informações, entre em contato com o SAC.</>
          ) : (
            <>Desculpe, mas esse pedido não possui seu tracking disponível, mas você <br />pode solicitar a posição de entrega para o nosso time de atendimento.</>
          )}
        </DescriptionTracking>
        {!shouldDisableCustomerPageTrackingProtocol && <BtnTracking action={createProtocol} />}
      </ContainerDescription>
    </ContainerTracking>
  );
};

export default HideTracking;